import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorComponent } from './error.component';

@NgModule({
    declarations: [ErrorComponent],
    imports: [BrowserModule, FormsModule]
})

export class ErrorModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/error/error.module.ts